import React, { Component, PropTypes } from 'react';
import './RadioField.css';

let rf = "radio-field"
let rfa = "radio-field__active"

class RadioField extends Component {

  handleClick(nextActive) {
    this.props.handleChange(nextActive, this.props.field.name)
  }

  render() {
    const { field } = this.props;
    return (
      <div className="radio-field-wrap">
        <p className="radio-field__label">
          {field.placeholder}
        </p>
        <p
          onClick={() => this.handleClick(false)}
          className={!field.value ? rf + ' ' + rfa : rf }>
         	No 
        </p>
        <p
          onClick={() => this.handleClick(true)}
          className={field.value ? rf + ' ' + rfa : rf }>
					Yes
        </p>
      </div>
    );
  }
}

RadioField.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired,
  }),
  handleChange: PropTypes.func.isRequired
};

export default RadioField;



/** WEBPACK FOOTER **
 ** ./src/components/RadioField/index.js
 **/